import usePageTitle from "@/hooks/usePageTitle";
import { useLocation } from "react-router-dom";
import { TagType } from "@/components/Tag/Tag";

export function useUniversityPageTitle(title: string | null | undefined) {
  const location = useLocation();
  usePageTitle(location.pathname, title);
}

export function getPageTitle(loading: boolean, content?: string, fallback?: string): string | null | undefined {
  if (loading) {
    return null;
  }

  if (content) {
    return content;
  }

  return fallback ? fallback : undefined;
}

export function formatStudentDetailTitle(universityName?: string, studentName?: string): string | undefined {
  if (universityName && studentName) {
    return `${universityName} | ${studentName}`;
  }
  return undefined;
}

export const getStatusTagColor = (status: string | null): TagType => {
  if (!status) return "surface";

  const statusColorMap: Record<string, TagType> = {
    Completed: "success",
    Qualifying: "warn",
    Qualified: "success",
    Registered: "warn",
    Passed: "success",
    Failed: "error",
    Incomplete: "surface",
    Complete: "success",
    Expired: "error",
    Pending: "warn",
    "In Progress": "warn",
    "On Probation": "warn",
    "In-Cohort": "success",
    "Out-of-Cohort": "warn",
    Attended: "success",
    Approved: "success",
    Active: "surface",
    "Not Started": "surface",
    Suspended: "error"
  };
  return statusColorMap[status] || "surface";
};
